import { api } from './api';

class ImportService {
  async uploadTeamsFile(file: File): Promise<{ success: boolean; message: string; storagePath: string }> {
    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post('/import/teams', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  }

  async uploadUsersFile(file: File): Promise<{ success: boolean; message: string; storagePath: string }> {
    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post('/import/users', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  }

  async downloadTeamsTemplate(): Promise<void> {
    const response = await api.get('/import/teams/template', {
      responseType: 'blob',
    });
    this.downloadBlob(response.data, 'template_equipes.xlsx');
  }

  async downloadUsersTemplate(): Promise<void> {
    const response = await api.get('/import/users/template', {
      responseType: 'blob',
    });
    this.downloadBlob(response.data, 'template_usuarios.xlsx');
  }

  private downloadBlob(blob: Blob, filename: string): void {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }
}

export const importService = new ImportService();
